import { GET_ADD_PRODUCT, GET_ADD_RFQ, GET_DELETE_PRODUCT, GET_DELETE_RFQ, GET_DRAFT_ORDERS, GET_ORDERS, GET_ORDERS_DETAIL, GET_RFQ, GET_STATUS, GET_UPDATE_ORDER, GET_UPDATE_RFQ, GET_VALUE } from "../ConstAction";

export const RFQs = (data,setLoading) => {

  return {
    type: GET_RFQ,
    data: data,
    setLoading: setLoading
  };
};

export const AddRFQ = (data, handleClose, setLoading) => {
  return {
    type: GET_ADD_RFQ,
    data: data,
    handleClose: handleClose,
    setLoading: setLoading
  };
};


export const deleteRFQ = (data, setLoading) => {
  return {
    type: GET_DELETE_RFQ,
    data: data,
    setLoading: setLoading
  };
};

export const addproduct = (data, payload, setLoading) => {
  return {
    type: GET_ADD_PRODUCT,
    data: data,
    payload: payload,
    setLoading:setLoading
  };
};

export const getdraftOrders = (data) => {
  return {
    type: GET_DRAFT_ORDERS,
    data: data,
  };
};

export const getOrders = (data, setLoading) => {
  return {
    type: GET_ORDERS,
    data: data,
    setLoading: setLoading
  };
};

export const statuses = (data) => {
  return {
    type: GET_STATUS,
    data: data,
  };
};



export const getOrdersDetail = (data) => {
  return {
    type: GET_ORDERS_DETAIL,
    data: data,
  };
};
export const deleteOrder = (data, payload, setLoading) => {
  return {
    type: GET_DELETE_PRODUCT,
    data: data,
    payload: payload,
    setLoading: setLoading
  };
};

export const updateOrder = (data, payload, setLoading) => {
  return {
    type: GET_UPDATE_ORDER,
    data: data,
    payload: payload,
    setLoading: setLoading
  };
};

export const value = (data) => {
  return {
    type: GET_VALUE,
    data: data
  }
}

export const updateRfq = (data,setLoading) => {
  return {
    type: GET_UPDATE_RFQ,
    data: data,
    setLoading: setLoading
  }
}